import React, { useState } from "react";
import TaskView from "../common/TaskView";
import { AcousticTask, AcousticTaskDefinition, SubTaskDefinition } from "../common/models";
import { randomUUID } from "../../../utils";
import { translateReactNode } from "../../../../utils/translateReactNode";
import { useTranslation } from "react-i18next";
import { TextBox } from "../../TextBox";

const texts = [
  `The blue spot is on the key again.`,
  `How hard did he hit him?`,
  `We were away a year ago.`,
  `We eat eggs every Easter.`,
  `My mama makes lemon muffins.`,
  `Peter will keep at the peak.`
]

const es419Texts = [
    "Este bus de aquí para poco en el mes de agosto.",
    "Hacen más fuerza si crece la asociación.",
    "Hoy no hay agua en el aula.",
    "Ayer. Hoy. Ahora. A tiempo.",
    "Me acompañan veinticinco niñas.",
    "Este paquete ocupa poco."
  ]

  const textsV2 = [
    "The blue spot is on the key again.",
    "He helped her hurry home.",
    "We were away a year ago.",
    "I eat eggs every morning.",
    "My mama makes lemon muffins.",
    "Papa took a piece of cake."
  ]

const Definition: AcousticTaskDefinition = {
  name: "Cape V sentences (v2)",
  title: "Cape V sentences",
  description: "",
  cohort: 'voice',
  type: 'acoustic-task',
  estimatedCompletionTime: '1:00',
  subTaskDefinitions: texts.map((text, index) => ({
    name: `Cape V sentences-${index + 1}`,
    title: "",
    instructions: `Please read the following sentences out loud in your typical voice.`,
    content: <TextBox text={text} />,
    gainProfile: 'speech',
    profileName: 'speech'
  }))
};
export const CapeVSentencesDefinition = Definition;

export const CapeVSentences = ({ onCompletion }: { onCompletion: () => void }) => {
  const { i18n } = useTranslation();

  const subTaskDefinitions: SubTaskDefinition[] = React.useMemo(() => {
    const textsToUse = i18n.language === 'es-419' ? es419Texts : textsV2;
    return textsToUse.map((text, index) => ({
      name: i18n.language === 'es-419'
        ? `Cape V sentences-${index + 1}`
        : `Cape V sentences-${index + 1} (v2)`,
      title: "",
      instructions: `Please read the following sentences out loud in your typical voice.`,
      content: <TextBox text={text} />,
      gainProfile: 'speech',
      profileName: 'speech'
    }));
  }, [i18n.language]);

  const definition: AcousticTaskDefinition = React.useMemo(() => ({
    name: i18n.language === 'es-419' ? "Cape V sentences" : "Cape V sentences (v2)",
    title: "Cape V sentences",
    description: "",
    cohort: 'voice',
    type: 'acoustic-task',
    estimatedCompletionTime: '1:00',
    subTaskDefinitions
  }), [subTaskDefinitions]);

  const [task, _setTask] = useState<AcousticTask>(() => ({
    ...definition,
    id: randomUUID(),
    startedAt: new Date().toISOString(),
    completedAt: null,
    status: 'pending',
    subTasks: definition.subTaskDefinitions.map((subDef) => ({
    ...subDef,
    id: randomUUID(),
    instructions: translateReactNode(subDef.instructions, definition.cohort),
    title: translateReactNode(subDef.title, definition.cohort) as string
    }))
  }));

  const handleOnCompletion = () => {
    console.log("Audio task completed", task.title);
    onCompletion();
  }

  return (
    <div>
      <TaskView
        task={task}
        onCompletion={handleOnCompletion}
        />
    </div>
  );
}

